import INDIVIDUAL_LIFE_FI from '../individual/individualLife.fi.json';
import INDIVIDUAL_LIFE_SV from '../individual/individualLife.sv.json';
import { LocalizationNamespace } from '../types';

const locales = {
  fi: {
    [LocalizationNamespace.individualLife]: INDIVIDUAL_LIFE_FI,
  },
  sv: {
    [LocalizationNamespace.individualLife]: INDIVIDUAL_LIFE_SV,
  },
};

export default locales;
